import styled from 'styled-components'
import { Flex } from '@pinchenterprisesnpm/friday-ui'

export const CheckboxCard = styled(Flex)`
  background: #fff;
  border: 1px solid ${({ theme: { palette } }) => palette.border};
  border-radius: 3px;
  transition: border 0.2s;
  cursor: pointer;
  &:hover {
    border: 1px solid ${({ theme: { palette } }) => palette.primary};
  }
`
